import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import TestPageShell from "./TestPageShell";
import TestReportContent from "./TestReportContent";
import { decodeTestNameFromPath } from "./testRoutes";

const TestReport: React.FC = () => {
  const { testName } = useParams<{ testName?: string }>();
  const [searchParams] = useSearchParams();
  const isDetailView = !!(
    decodeTestNameFromPath(testName) && searchParams.get("test_id")
  );

  return (
    <TestPageShell
      showCardSearch
      searchPlaceholder={isDetailView ? "Search students..." : "Search tests..."}
      searchAriaLabel={isDetailView ? "Search students" : "Search tests"}
    >
      <TestReportContent />
    </TestPageShell>
  );
};

export default TestReport;
